<template>
  <el-form
    :model="form"
    ref="form">
    <div class="row">
      <div class="col-12 col-md-6">
        <el-form-item
          :label="L10n('part-number')"
          prop="partNumber"
          :rules="getValidationRule('required')"
          class="material-style">
          <el-input
            :value="form.partNumber"
            @input="form.partNumber = valueTrimLeft($event)"/>
        </el-form-item>
      </div>
      <div class="col-12 col-md-6">
        <el-form-item
          :label="L10n('part-description')"
          prop="partDescription"
          :rules="getValidationRule('required')"
          class="material-style">
          <el-input
            :value="form.partDescription"
            @input="form.partDescription = valueTrimLeft($event)"/>
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-6">
        <el-form-item
          :label="L10n('manufacturer')"
          prop="manufacturerID"
          class="material-style">
          <select-response-auto-complete
            :model.sync="form.manufacturerID"
            api="Companies/GetAllDynamic"
            :fields="{id: 'id', title: 'name'}"/>
        </el-form-item>
      </div>
      <div class="col-12 col-md-6">
        <el-form-item
          :label="L10n('aircraft')"
          prop="aircraftID"
          class="material-style">
          <select-response-auto-complete
            :model.sync="form.aircraftID"
            api="Aircrafts/GetAllDynamic"
            :fields="{id: 'id', title: 'aircraftModel'}"
            :orderBy="{fields: 'aircraftModel', order: ''}"/>
        </el-form-item>
      </div>
    </div>
    <view-more>
      <div class="row">
        <div class="col-12 col-md-6 price-field">
          <el-form-item
            :label="L10n('list-price')"
            prop="listPrice"
            :rules="getValidationRule('number')"
            class="price-field__field material-style">
            <el-input
              :value="form.listPrice"
              @input="form.listPrice = valueNumber($event)"/>
          </el-form-item>
          <el-form-item
            prop="priceCurrencyID"
            class="price-field__value material-style">
            <select-response
              :model.sync="form.priceCurrencyID"
              :data="dataSourceCurrency.records"
              :isLoading="dataSourceCurrency.isLoading"
            ></select-response>
          </el-form-item>
        </div>
        <div class="col-12 col-md-6">
          <el-form-item
            :label="L10n('list-price-date')"
            prop="listPriceDate"
            class="material-style">
            <date-picker
              type="date"
              v-model="form.listPriceDate"
            />
          </el-form-item>
        </div>
      </div>
      <div class="row">
        <div class="col-6 col-md-6">
          <el-form-item
            :label="L10n('remark')"
            prop="remark"
            class="material-style">
            <el-input
              type="textarea"
              :rows="3"
              v-model="form.remark"/>
          </el-form-item>
        </div>
        <div class="col-6 col-md-6">
          <el-form-item
            :label="L10n('technical-remark')"
            prop="technicalRemark"
            class="material-style">
            <el-input
              type="textarea"
              :rows="3"
              v-model="form.technicalRemark"/>
          </el-form-item>
        </div>
      </div>
    </view-more>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'

export default {
  name: 'FormSelectPartNumber',
  mixins: [Form],
  components: {
    'view-more': () => import(/* webpackChunkName: 'UI' */ '@/components/UI/ViewMore.vue')
  },
  computed: {
    dataSourceCurrency () {
      return this.API('Currencies/GetAllDynamic?select=id,title')
    }
  }
}
</script>
